<template>
  <div>
    <Header :image="storeInfo.image">
      {{ storeInfo.name }}
    </Header>
    <main id="#main">
      <section class="c-section">
        <div class="p-time__menu c-card-default">
          <ul>
            <li v-for="(menu, menuIndex) in targetMenu" :key="menuIndex">{{ menu.name }}：¥{{ menu.price.toLocaleString() }}</li>
          </ul>
          <div>
            <router-link tag="p" :to="'/' + this.$route.params.storeid + '/menu/'" class="c-btn--tertiary c-btn--small">
              変更
            </router-link>
          </div>
        </div>
        <p class="c-text__notice u-mw20">
          目安施術時間：{{ minToHour(sumMinutes(targetMenu)) }}
        </p>
      </section>
      <section>
        <h2 class="c-level2">
          <span>
            予約日時を選ぶ
          </span>
        </h2>
        <div class="p-time__week">
          <p class="c-btn--secondary c-btn--small" @click="loadWeek(-7)" v-if="isAfterToday(calendarInfo.availableTimes[0].date)">前週</p>
          <p class="c-btn--secondary c-btn--small c-btn--disabled" v-else>前週</p>
          <p>
            {{displayFullYear(calendarInfo.availableTimes[0].date)}}年{{displayMonth(calendarInfo.availableTimes[0].date)}}月{{displayDate(calendarInfo.availableTimes[0].date)}}日〜{{displayMonth(calendarInfo.availableTimes[6].date)}}月{{displayDate(calendarInfo.availableTimes[6].date)}}日
            </p>
          <p class="c-btn--secondary c-btn--small" @click="loadWeek(7)">翌週</p>
        </div>
        <table class="p-time__calender">
          <thead>
            <tr>
              <th>
              </th>
              <th>
                <p>月</p>
                <p>{{displayDate(calendarInfo.availableTimes[0].date)}}</p>
              </th>
              <th>
                <p>火</p>
                <p>{{displayDate(calendarInfo.availableTimes[1].date)}}</p>
              </th>
              <th>
                <p>水</p>
                <p>{{displayDate(calendarInfo.availableTimes[2].date)}}</p>
              </th>
              <th>
                <p>木</p>
                <p>{{displayDate(calendarInfo.availableTimes[3].date)}}</p>
              </th>
              <th>
                <p>金</p>
                <p>{{displayDate(calendarInfo.availableTimes[4].date)}}</p>
              </th>
              <th>
                <p>土</p>
                <p>{{displayDate(calendarInfo.availableTimes[5].date)}}</p>
              </th>
              <th>
                <p>日</p>
                <p>{{displayDate(calendarInfo.availableTimes[6].date)}}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(time, timeIndex) in calendarInfo.availableTimes[0].times" :key="timeIndex">
              <th>{{ time.time }}</th>
              <td v-for="(availableTime, index) in calendarInfo.availableTimes"
                :key="index"
                :class="{available: availableTime.times[timeIndex].status === 0, tel: availableTime.times[timeIndex].status === 3}"
                @click="clickTime(availableTime, timeIndex)">
                <span v-if="availableTime.times[timeIndex].status === 0">◎</span>
                <span v-else-if="availableTime.times[timeIndex].status === 3">TEL</span>
                <span v-else>×</span>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </main>
    <Footer />
    <Modal v-on:close="closeModal('temporaryReservation')" v-if="modal.temporaryReservation">
      <h3>ご予約内容</h3>
      <ul class="c-defList">
        <li>
          <dl>
            <dt>予約日時</dt>
            <dd>
              <p>{{displayFullYear(targetDate)}}年{{displayMonth(targetDate)}}月{{displayDate(targetDate)}}日</p>
              <p>
                {{ displayHours(targetDate, targetTime.time) }}〜{{ displayHours(targetDate, targetTime.time, sumMinutes(targetMenu)) }}
              </p>
              </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>メニュー</dt>
            <dd>
              <p v-for="(menu, menuIndex) in targetMenu" :key="menuIndex">{{ menu.name }}：¥{{ menu.price.toLocaleString() }}</p>
              <p class="c-price__total">合計：¥{{ sumPrice(targetMenu).toLocaleString() }}</p>
            </dd>
          </dl>
        </li>
        <li>
          <label class="c-label" for="mail">メールアドレス</label>
          <input type="text" placeholder="例：sample@memorii.jp" id="mail" class="c-inputText" v-model.trim="$v.mail.$model">
          <ul class="c-validateError" v-show="$v.mail.$error">
            <li v-show="!$v.mail.required">入力が必須の項目です。</li>
            <li v-show="!$v.mail.email">メールアドレスの形式で入力してください。</li>
            <li v-show="!$v.mail.maxLength">最大文字数を超えています。</li>
          </ul>
          <p class="c-text__notice--min">※メール受信制限されている方は、memorii.jpからのメール受信を許可してください。</p>
        </li>
      </ul>
      <p class="c-text__notice--center u-mt30">
        <a @click="openBlankLink('/terms')">利用規約</a>、<a @click="openBlankLink('/privacy')">プライバシーポリシー</a> に同意して
      </p>
      <p class="c-btn--primary" @click="clickTempReserveBtn()" v-if="!$v.mail.$invalid">
        メールアドレスで予約する
      </p>
      <p class="c-btn--primary c-btn--disabled" v-else>
        メールアドレスで予約する
      </p>
    </Modal>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Modal from '@/components/Modal.vue'
import { mapState, mapActions } from 'vuex'
import { Mixin } from '@/mixin'
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'app',
  data () {
    return {
      modal: {
        temporaryReservation: false
      },
      targetDate: '',
      targetTime: {},
      mail: '',
      validate: true,
      error: []
    }
  },
  head: {
    title: function () {
      return {
        inner: this.storeInfo.name,
        separator: '|',
        complement: '日時選択'
      }
    }
  },
  components: {
    Header,
    Modal,
    Footer
  },
  computed: {
    ...mapState({
      storeInfo: 'storeInfo',
      calendarInfo: 'calendarInfo',
      targetMenu: 'targetMenu'
    })
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      const targetDate = new Date()
      const monday = targetDate.getDay() !== 0 ? targetDate.getDate() - targetDate.getDay() + 1 : targetDate.getDate() - targetDate.getDay() - 6
      const mondayDiff = targetDate.getDate() - monday
      targetDate.setDate(targetDate.getDate() - mondayDiff)
      const date = targetDate.getFullYear() + ('0' + (targetDate.getMonth() + 1)).slice(-2) + ('0' + targetDate.getDate()).slice(-2)
      vm.$store.commit('SET_LOADING', true)
      promises.push(vm.$store.dispatch('LOAD_STORE_INFO', { storeid: route.params.storeid }))
      let minutes = Mixin.methods.sumMinutes(vm.$store.state.targetMenu)
      promises.push(vm.$store.dispatch('LOAD_CALENDAR_INFO', { storeid: route.params.storeid, date: date, minutes }))
      await Promise.all(promises).then(function () {
        vm.$emit('updateHead')
        vm.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        alert(error.message)
      })
    })
  },
  mixins: [Mixin, validationMixin],
  methods: {
    ...mapActions(['LOAD_STORE_INFO', 'LOAD_CALENDAR_INFO']),
    loadWeek: async function (diff) {
      const promises = []
      const that = this
      const targetDate = this.createDate(this.calendarInfo.availableTimes[0].date)
      targetDate.setDate(targetDate.getDate() + diff)
      const date = this.createMonday(targetDate)
      this.$store.commit('SET_LOADING', true)
      promises.push(this.$store.dispatch('LOAD_CALENDAR_INFO', { storeid: this.$route.params.storeid, date: date, minutes: this.sumMinutes(this.targetMenu) }))
      await Promise.all(promises).then(function () {
        that.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        alert(error.message)
      })
    },
    clickTime: function (availableTimes, timeIndex) {
      if (availableTimes.times[timeIndex].status === 0) {
        this.targetDate = availableTimes.date
        this.targetTime = availableTimes.times[timeIndex]
        this.openModal('temporaryReservation')
        this.createDate(this.targetDate)
      }
    },
    openBlankLink: function (url) {
      const routeData = this.$router.resolve({ path: url })
      window.open(routeData.href, '_blank')
    },
    clickTempReserveBtn: async function () {
      const promises = []
      const that = this
      const payload = {
        id: this.$route.params.storeid,
        date: this.targetDate,
        startAt: this.displayHours(this.targetDate, this.targetTime.time),
        menus: [],
        mail: this.mail
      }
      for (let i = 0; i < this.targetMenu.length; i++) {
        payload.menus.push(this.targetMenu[i].id)
      }
      this.$store.commit('SET_LOADING', true)
      promises.push(this.$store.dispatch('SEND_TEMP_RESERVATION', payload))
      await Promise.all(promises).then(function () {
        that.$store.commit('SET_LOADING', false)
        that.$router.push({ path: '/' + that.$route.params.storeid + '/temp/' })
      }).catch(function (error) {
        that.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    },
    isAfterToday: function (dateStr) {
      const now = new Date()
      let dateArr = (dateStr.substr(0, 4) + '/' + dateStr.substr(4, 2) + '/' + dateStr.substr(6, 2)).split('/')
      let targetDate = new Date(dateArr[0], dateArr[1] - 1, dateArr[2])
      if (now < targetDate) {
        return true
      } else {
        return false
      }
    }
  },
  validations: {
    mail: {
      required,
      email,
      maxLength: maxLength(100)
    }
  }
}
</script>
